import {
  MinusOutlined,
  PlusOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import classNames from 'classnames';
import React, { useState } from 'react';
import styles from './BillingGuarantee.module.css';

export const BillingGuarantee = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={classNames(styles.container, {
        [styles.collapsedContainer]: !isExpanded,
      })}
    >
      <div className={styles.header} onClick={() => setIsExpanded(!isExpanded)}>
        <span className={styles.title}>
          <SafetyCertificateOutlined className={styles.certificateIcon} />{' '}
          Customers.ai Guarantee
        </span>
        {isExpanded ? (
          <MinusOutlined className={styles.headerIcon} />
        ) : (
          <PlusOutlined className={styles.headerIcon} />
        )}
      </div>
      {isExpanded && (
        <div className={styles.content}>
          <div className={styles.contentTitle}>
            Customers.ai for Meta Advertisers Event Match Quality Score
            Guarantee
          </div>
          <div className={styles.list}>
            <div className={styles.listTitle}>
              See an improvement in any of the following Meta results in 90 days
              or cancel anytime with no questions asked.
            </div>
            <ul>
              <li>20% or more Increase in Event Match Quality Score</li>
              <li>15% or more increase in reported conversions</li>
              <li>15% or more decrease in CAC</li>
              <li>10% or more increase in ROAS</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};
